const globalStyles = (theme) => {
    if (process.env.NODE_ENV !== 'production') {
        console.log("Structure of the theme")
        console.log(theme)
    }

    return {
        '@global': {
            '@import': [
                'url(https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css)',
                'url(https://fonts.googleapis.com/css?family=Roboto:300,400,500)'
            ],
            html: {
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
                fontWeight: 400,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontSize: 16,
                lineHeight: 1.5
            },
            pre: {
                fontWeight: 400,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontSize: 13,
                lineHeight: '1rem',
                margin: 0
            },
            body: {
                margin: 0,
            },
            div: {
                '&:focus': {
                    outline: 'none'
                }
            },
            ul: {
                margin: 0,
                padding: 0,
                '&:focus': {
                    outline: 'none'
                }
            },
            p: {
                lineHeight: 1.5,
                margin: `0 0 ${theme.spacing.normal}px`
            },
            '.flow': {
                margin: `0 0 ${theme.spacing.normal}px`
            },
            '.flow-small': {
                margin: `0 0 ${theme.spacing.small}px`
            },
            '.flowLeft': {
                marginLeft: theme.spacing.normal
            },
            'h1,h2,h3,h4,h5': {
                margin: `0 0 ${theme.spacing.normal}px`
            },
            a: {
                textDecoration: 'none',
                cursor: 'pointer',
            },
            /*a: {
                color: theme.palette.primary['500'],
                textDecoration: 'none',
                transition: 'color 0.1s ease',
                cursor: 'pointer',
                '&:hover': {
                    color: theme.palette.secondary['500'],
                    textDecoration: 'underline',
                }
            },*/
            '.cell-sm-up': {
                display: 'none',
                [theme.breakpoints.up('sm')]: {
                    display: 'table-cell',
                }
            },
        },
    }
}

export default globalStyles;


// WEBPACK FOOTER //
// ./src/style/global.js